export const CHAT_LAYOUT_DOM_ID = 'chat-layout';
export const CHAT_ROOT_ELEMENT_DOM_ID = 'sg-chat-container';
